import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * 指定した外部URLへリダイレクトするコンポーネント
 * @param {Object} props
 * @param {string} props.to - リダイレクト先のURL
 * @returns {JSX.Element}
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    if (to) {
      window.location.replace(to);
    }
  }, [to]);

  if (!to) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body2">リダイレクト中...</Typography>
    </Box>
  );
};

export default ExternalRedirect;
